import React from 'react';
import {
  Box,
  IconButton,
  Tooltip,
} from '@material-ui/core';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';

import EmptyState from 'src/components/EmptyState';
import useModal from 'src/components/Modal/useModal';
import HttpLedger from 'src/components/HttpLedger';
import getTaskStatusLabel from 'src/utils/getTaskStatusLabel';
import TaskCell from 'src/components/cells/TaskCell';
import AssignedCompletedCell from 'src/components/cells/AssignedCompletedCell';
import Ledger from 'src/components/Ledger';
import UserCell from 'src/components/cells/UserCell';
import TaskHandlerModal from 'src/views/shared/TaskHandlerModal';
import EngagementNameCell from 'src/components/cells/EngagementNameCell';

import { TaskWithDetailedTriggeredAction } from 'src/types';
import Content from '../../components/Content';

interface Props {
  url: string,
  httpLedgerProps?: any,
}

function TasksLedger({
  url,
  httpLedgerProps,
}: Props) {
  const {
    isOpen,
    openModal,
    closeModal,
    modalContent
  } = useModal();

  const columns = [
    {
      title: 'Task',
      cellContent: (task: TaskWithDetailedTriggeredAction) => <TaskCell task={task} />,
    },
    {
      title: 'Engagement',
      cellContent: (task: TaskWithDetailedTriggeredAction) => (
        <EngagementNameCell engagement={task.engagement} />
      )
    },
    {
      title: 'Assigned to',
      cellContent: (task: TaskWithDetailedTriggeredAction) => <UserCell accounts={[task.assignedTo]} />
    },
    {
      title: 'Assigned at',
      cellContent: (task: TaskWithDetailedTriggeredAction) => <AssignedCompletedCell task={task} />
    },
    {
      title: 'Due date',
      cellContent: (task: TaskWithDetailedTriggeredAction) => (
        <Box>
          {getTaskStatusLabel(task)}
        </Box>
      )
    },
    {
      cellContent: (task: TaskWithDetailedTriggeredAction) => (
        <Tooltip title="View task">
          <IconButton
            edge="end"
            onClick={() => openModal(task)}
          >
            <OpenInNewIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      ),
    },
  ];

  return (
    <HttpLedger
      defaultPageSize={6}
      url={url}
      columns={columns}
      emptyState={<EmptyState />}
      defaultFilters={{
        is_incomplete: 'True'
      }}
      {...httpLedgerProps}
      render={({
        fetchData,
        ..._ledgerProps
      }: any) => (
        <>
          {
              isOpen && (
                <TaskHandlerModal
                  task={modalContent}
                  onClose={closeModal}
                  onSuccess={fetchData}
                  {...modalContent}
                />
              )
            }
          <Ledger {..._ledgerProps} />
        </>
      )}
    />
  );
}

export default TasksLedger;
